export default __webpack_public_path__ + "static/logo-arkitekt-negativ-5b1f8ed14db4f51154be1b6b0a227eb3.png";